/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImageAddImageUploadRequest } from "../models/ImageAddImageUploadRequest";
import type { ImageAddImageUploadResponseApiRespoonse } from "../models/ImageAddImageUploadResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class ImageManagementService {
  /**
   * Add new file upload
   * @param requestBody
   * @returns ImageAddImageUploadResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static imagesAddImageUpload(
    requestBody: ImageAddImageUploadRequest
  ): CancelablePromise<ImageAddImageUploadResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/images/add-image-upload",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
